import {
  TrackerConfig as ITrackerConfig,
  TrackerEvent as ITrackerEvent,
  TrackerInstance as ITrackerInstance
} from './src/utils/events/tracker-factory';
import {
  NetworkResponse as INetworkResponse,
  NetworkConfig as INetworkConfig,
  NetworkRequestConfig as INetworkRequestConfig,
  NetworkInstance as INetworkInstance
  } from './src/utils/network/network-factory';
import { InputValidator as IInputValidator } from './src/utils/validators/form-validators';

// hooks
export { default as useCookie } from './src/hooks/use-cookie';
export { default as useGetPhoneNumber } from './src/hooks/use-get-phone-number';
export { default as useMarketoForm } from './src/hooks/use-marketo-form';
export { default as useMarketoLink } from './src/hooks/use-marketo-link';
export { default as usePathPrefix } from './src/hooks/use-path-prefix';
export { default as useRedirects } from './src/hooks/use-redirects';
export { default as useSiteMetadata } from './src/hooks/use-site-metadata';

// tests
export { default as getMockLocation } from './src/tests/location';
export { default as getMockPageContext } from './src/tests/page-context';

// utils
export {
  pollingFunction,
  getFeatureFlags,
  filterFeatureFlags,
  isTestActive,
  userIsRegisteredAndNotLoggedIn,
  getAllQueryParams
} from './src/utils/ab-tests/helpers';
export { default as BeaconAdapter } from './src/utils/events/beacon-adapter';
export { default as KissmetricsAdapter } from './src/utils/events/kissmetrics-adapter';
export { default as sendBeaconEvent } from './src/utils/events/send-beacon-event';
export { default as TrackerFactory, TrackerType } from './src/utils/events/tracker-factory';
export { default as NetworkFactory, NetworkServiceType } from './src/utils/network/network-factory';
export { InputDefaultValidator, InputPasswordValidator, InputEmailValidator } from './src/utils/validators/form-validators';
export { initialLandingPage } from './src/utils/cookies';
export { default as setupCookieSync, getIframeUrl } from './src/utils/cookieSync';
export { default as createMetatags } from './src/utils/createMetatags';
export { resetDrift, hideDrift, showDrift } from './src/utils/drift';
export {
  default as getEnv,
  isDev,
  isTest,
  isProd,
  isPreProd,
  isStaging
} from './src/utils/env';
export { default as formatTranslationPath } from './src/utils/formatTranslationPath';
export { default as gatsbyGraphqlConfig } from './src/utils/gatsbyGraphqlConfig';
export { default as gtmConfig } from './src/utils/googleTagManager';
export { default as getDrupalMenu } from './src/utils/getDrupalMenu';
export { default as getEntityFields } from './src/utils/getEntityFields';
export { default as getI18nData } from './src/utils/getI18nData';
export { default as getInternalLink } from './src/utils/getInternalLink';
export { default as getLinkPath } from './src/utils/getLinkPath';
export { default as isAnchorPath } from './src/utils/isAnchorPath';
export { default as isBrowser } from './src/utils/isBrowser';
export { default as isBrowserIE } from './src/utils/isBrowserIE';
export { default as isEmpty } from './src/utils/isEmpty';
export { default as isIE11 } from './src/utils/isIE11';
export { i18nLanguageMapping, templateLanguageMapping } from './src/utils/languageMapping';
export { default as languages } from './src/utils/languages';
export { default as isWindowAboveWidth } from './src/utils/isWindowAboveWidth';
export { default as localizePhoneNumbers } from './src/utils/localizePhoneNumbers';
export {
  default as marketoFormIds,
  allMarketoForms,
  checkForMarketoFields,
  retrieveMarketoIds
} from './src/utils/marketoForms';
export { default as getProcessedValue } from './src/utils/getProcessedValue';
export { default as productDomains, productDomainEnv } from './src/utils/productDomains';
export { registerUserEmailOnly, registerFullFields } from './src/utils/registration';
export { default as seeder } from './src/utils/seeder';
export { default as shortLangPrefix } from './src/utils/shortLangPrefix';
export { default as withCookieSyncParams } from './src/utils/withCookieSyncParams';
export { default as withCookieUrlParams } from './src/utils/withCookieUrlParams';

// types
export type InputValidator = IInputValidator;
export type TrackerConfig = ITrackerConfig;
export type TrackerEvent = ITrackerEvent;
export type TrackerInstance = ITrackerInstance;
export type NetworkResponse = INetworkResponse;
export type NetworkConfig = INetworkConfig;
export type NetworkRequestConfig = INetworkRequestConfig;
export type NetworkInstance = INetworkInstance;

// export all (must be at end of file)
export * from './src/types';
